<!--
  공통
  로그인 계정 정보 팝업

  @since 2018-12-27
  @author mk.ko
-->

<template>

  <layout-popup ref="layoutPopUp"
                :titleName="$t('cmn.myAccountInfoEdit')"
                :footerBtn="footerBtn"
                :content-css="popupContentCss"
                :confirmEvt="onConfirm">

    <div class="content-group">
      <div class="contents-row" v-if="tempMyAccountInfo">

        <!-- 일반 설정 -->
        <div class="content-group">
          <div class="contents-row">

            <div class="contents-row">
              <div class="page-title-2depth">
                <span class="page-title-2depth-text">{{$t('sm.adminGeneralSetting_generalTab_title')}}</span>
              </div>
            </div>

            <div class="contents-row">
              <!-- 컨텐츠 패널 시작 -->
              <div class="portlet">
                <div class="contents-row">
                  <!-- 테이블 시작 -->
                  <table class="bs-table table-bordered-none">

                    <colgroup>
                      <col width="25%"/>
                      <col width="auto"/>
                      <col width="auto"/>
                    </colgroup>

                    <tbody>

                      <tr>
                        <td class="td-head">ID</td>
                        <td>
                          <div class="inline-group">
                            <q-input v-model="tempMyAccountInfo.admin_login_uname"
                                     disable
                                     class="bs bs-q-input bs-q-input-default"
                                     style="width:210px;">
                            </q-input>
                          </div>
                        </td>
                        <td rowspan="7">
                          <div class="inline-group">
                            <div>
                              <template v-if="!profileImagePath">
                                <div class="text-center" style="display:inline-block; width:180px;">
                                  <div class="img-preview" style="width:100%; height:225px;">
                                    <span class="img-preview-text" style="left:0; right:0;">{{ $t('sm.deviceConfig_deviceConfigSep_noImage') }}</span>
                                  </div>
                                </div>
                              </template>
                              <template v-else>
                                <img ref="preview"
                                     :src="profileImagePath"
                                     style="max-width: 357px; height: 225px;">
                              </template>
                            </div>
                          </div>
                          <div class="inline-group">

                            <!-- 이미지 업로드 -->
                            <q-uploader ref="profileImageUploader"
                                        class="bs bs-q-uploader bs-q-uploader-default"
                                        style="width:270px;margin:auto;"
                                        :url="profileImageUrl"
                                        :disable="isCheckIn"
                                        no-thumbnails
                                        hide-upload-button
                                        hide-upload-progress
                                        :extensions="fileExtensions"
                                        @add="onFileSelected"
                                        @remove:cancel="onFileRemoved"
                            />

                            <div>
                              <q-btn class="bs bs-q-btn-sm bs-q-btn-line"
                                     style="margin-left:10px;"
                                     color="primary"
                                     outline="outline"
                                     :disable="isCheckIn"
                                     :label="$t('sm.adminGroupSettings_profilePicRemove')"
                                     @click="onRemovePhoto">
                              </q-btn>
                            </div>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td class="td-head">{{ $t('cmn.userPassword') }}</td>
                        <td>
                          <div class="inline-group">
                            <q-btn :label="$t('cmn.changingPassword')"
                                   color="primary"
                                   outline="outline"
                                   :disable="isCheckIn"
                                   class="bs bs-q-btn-sm bs-q-btn-line"
                                   @click="onPasswordChange">
                            </q-btn>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td class="td-head">{{ $t('cmn.name') }} <span class="textR">*</span></td>
                        <td>
                          <div class="inline-group">
                            <q-input v-model="tempMyAccountInfo.admin_name"
                                     class="bs bs-q-input bs-q-input-default"
                                     style="width:210px;"
                                     :disable="isCheckIn"
                                     minlength="2"
                                     maxLength="32"
                                     name="uname"
                                     data-vv-scope="myaccount"
                                     :error="errors.has('myaccount.uname')"
                                     v-validate="'required'">
                              <tool-tip maxValue="32"></tool-tip>
                            </q-input>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td class="td-head">{{ $t('cmn.userMail') }}</td>
                        <td>
                          <div class="inline-group">
                            <q-input v-model="tempMyAccountInfo.admin_email"
                                     class="bs bs-q-input bs-q-input-default"
                                     style="width:210px;"
                                     :disable="isCheckIn"
                                     maxLength="128"
                                     name="email"
                                     data-vv-scope="myaccount"
                                     :error="errors.has('myaccount.email')"
                                     v-validate="'isValidEmail'">
                              <tool-tip maxValue="128"></tool-tip>
                            </q-input>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td class="td-head">{{ $t('cmn.depart') }}</td>
                        <td>
                          <div class="inline-group">
                            <q-input v-model="tempMyAccountInfo.admin_depart_name"
                                     class="bs bs-q-input bs-q-input-default"
                                     style="width:210px;"
                                     :disable="isCheckIn"
                                     maxLength="32">
                              <tool-tip maxValue="32"></tool-tip>
                            </q-input>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td class="td-head">{{ $t('cmn.tel') }}</td>
                        <td>
                          <div class="inline-group">
                            <q-input v-model="tempMyAccountInfo.admin_phone"
                                     class="bs bs-q-input bs-q-input-default"
                                     style="width:210px;"
                                     :disable="isCheckIn"
                                     name="phone"
                                     data-vv-scope="myaccount"
                                     :error="errors.has('myaccount.phone')"
                                     v-validate="'isOnlyNumberHyphen'"
                                     maxLength="16">
                              <tool-tip maxValue="16"></tool-tip>
                            </q-input>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td class="td-head">{{ $t('cmn.description') }}</td>
                        <td colspan=2>
                          <div class="inline-group">
                            <q-input v-model="tempMyAccountInfo.admin_desc"
                                     class="bs bs-q-input bs-q-input-default"
                                     :disable="isCheckIn"
                                     maxLength="128"
                                     name="desc"
                                     data-vv-scope="myaccount"
                                     :error="errors.has('myaccount.desc')"
                                     style="width:210px;">
                              <tool-tip maxValue="128"></tool-tip>
                            </q-input>
                          </div>
                        </td>
                      </tr>

                    </tbody>
                  </table>
                  <!-- 테이블 끝 -->
                </div>
              </div>

            </div>
          </div>
        </div>
        <!-- 일반 설정 끝 -->

        <!-- 컨텐츠 분할 시작 -->
        <div class="contents-clearfix"></div>
        <!-- 컨텐츠 분할 끝 -->

        <!-- 고급 설정 -->
        <div v-if="!ccFlag" class="content-group">
          <div class="contents-row">

            <div class="contents-row">
              <div class="page-title-2depth">
                <span class="page-title-2depth-text">{{$t('sm.interfaceSettings_grid_btnAdvanceTitle')}}</span>
              </div>
            </div>

            <div class="contents-row">
              <div class="portlet">
                <div class="contents-row">

                  <!-- 테이블 시작 -->
                  <table class="bs-table table-bordered-none">
                    <colgroup>
                      <col width="25%"/>
                      <col width="auto"/>
                    </colgroup>
                    <tbody>

                    <tr>
                      <td class="td-head">SECUI OTP <span class="textR">*</span></td>
                      <td>
                        <div class="inline-group"><!-- class="block-group"은 세로 정렬 / class="inline-group"은 가로 정렬 -->

                          <q-toggle v-model="tempMyAccountInfo.admin_otp_enable_yn"
                                    :disable="isCheckIn"
                                    :true-value="1"
                                    :false-value="0"
                                    class="bs bs-q-toggle bs-q-toggle-default"/>
                          <!-- OTP 키 설정 -->
                          <q-btn :label="$t('cmn.setting')"
                                 @click="onClickSecuiOtp"
                                 color="primary"
                                 outline="outline"
                                 class="bs bs-q-btn-sm bs-q-btn-line"
                                 :disable="isCheckIn"
                          >
                            <tool-tip :message="$t('sm.otpKeySetting')"></tool-tip>
                          </q-btn>
                          <!-- OTP 사용 메뉴 설정 -->
                          <q-btn color="primary"
                                 outline="outline"
                                 @click="onClickSecuiOtpMenu"
                                 class="bs bs-q-btn-sm bs-q-btn-icon-sm bs-q-btn-line">
                            <q-icon class="bs-q-btn-icon bs-q-btn-icon-setting-sm"></q-icon>
                            <tool-tip :message="$t('sm.otpUseMenuSetting')"></tool-tip>
                          </q-btn>

                          <q-btn color="primary" size="sm" round class="bs bs-q-btn-sm bs-q-btn-page-title">
                            <span class="page-title-1depth-img"></span>
                            <q-tooltip anchor="bottom middle" self="top left" :offset="[10, 10]"
                                       class="bs bs-q-tooltip bs-q-tooltip-default">
                              <div class="bs-q-tooltip-contents">
                                {{ $t('msg.changeOtpSettings') }}
                              </div>
                            </q-tooltip>
                          </q-btn>

                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class="td-head">{{$t('cmn.useLanguage')}} <span class="textR">*</span></td>
                      <td>
                        <div class="inline-group">
                          <q-select v-model="tempMyAccountInfo.admin_locale_type"
                                    :options="localeItems"
                                    :disable="isCheckIn"
                                    class="bs bs-q-select bs-q-select-default f-left"
                                    style="min-width: 142px;"
                          >
                          </q-select>

                          <q-btn color="primary" size="sm" round class="bs bs-q-btn-sm bs-q-btn-page-title">
                            <span class="page-title-1depth-img"></span>
                            <q-tooltip anchor="bottom middle" self="top left" :offset="[10, 10]"
                                       class="bs bs-q-tooltip bs-q-tooltip-default">
                              <div class="bs-q-tooltip-contents">
                                {{ $t('msg.changeLanguageSettings') }}
                              </div>
                            </q-tooltip>
                          </q-btn>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 언어 설정 끝 -->


      </div>
    </div>

    <loading-dialog ref="globalLoadingDialog"/>
    <alert-dialog ref="globalAlertDialog"/>

    <!--  비밀번호 변경 -->
    <password-change-popup ref='passwordChangePopup'
                           my-account-settings/>

    <admin-otp-popup ref="adminOtpPopup"
                     :isReadOnly="isCheckIn"
                     @confirm="onConfirmOtpKey"
    />
    <contents-dialog ref="contentsSetPopup"
                     :isReadOnly="isCheckIn"
                     :contents="otpMenu"
                     :title="$t('sm.otpUseMenuSetting')"
                     :footerBtnList="['confirm', 'cancel']"
                     :match-use-key="'admin_otp_menu_enable_yn'"
                     :match-id-key="'admin_otp_menu_id'"
                     :match-name-key="'admin_otp_menu_name'"
                     @apply="onConfirmOtpMenu"
    ></contents-dialog>

  </layout-popup>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'

  // components
  import LayoutPopup from '~/components/popUp/LayoutModalPopUp'
  import LoadingDialog from '~/components/dialog/LoadingDialog'
  import AlertDialog from '~/components/dialog/AlertDialog'
  import AdminOtpPopup from '~/pages/system/adminSettings/administratorPopup/adminOtpPopup'
  import ContentSetPopUp from '~/components/popUp/ContentSetPopUp'

  import { PasswordChangePopup } from '~/components/pageComponents/system/adminSettings/adminGroupSettings'

  // utils
  import path from 'path'
  import { fileSizeConverter } from '~/utils/charts'
  import compareObject from '~/utils/compare'

  // stores
  const myAccountSettingsHelpers = createNamespacedHelpers('common/myAccountSettings')
  const multirwHelpers = createNamespacedHelpers('common/multirw')

  export default {
    name: 'MyAccountSettings',
    components: {
      LayoutPopup,
      LoadingDialog,
      AlertDialog,
      PasswordChangePopup,
      AdminOtpPopup,
      'contents-dialog': ContentSetPopUp
    },
    directives: {},
    mixins: [],
    data () {
      return {
        profileImageFile: void 0,
        profileImageUrl: '',
        profileImagePath: '',
        profileAction: 0, // 0: not changing, 1: update, 2: delete
        tempMyAccountInfo: {},
        fileExtensions: '.gif,.jpg,.jpeg,.png',
        uploadMaxSize: 1000 * 1000 * 10, // 10mb 사이즈 제한
        beforeApplyOtpMenu: [],
        otpMenu: [],
        updatedOtpMenu: []
      }
    },
    computed: {
      ...myAccountSettingsHelpers.mapState([
        'myAccountInfo'
      ]),
      ...multirwHelpers.mapGetters([
        'isLock',
        'isCheckIn',
        'isReadOnly',
        'isReload',
        'isConfirmCheckOut',
        'lockInfo',
        'thisMenuInfo'
      ]),
      adminId () {
        return this.$store.state.common.common.uiData.user.adm_id
      },
      ccFlag () {
        try {
          return this.$store.state.common.common.uiData.system.cc_flag
        } catch (e) {
          return false
        }
      },
      popupContentCss () {
        try {
          let res = {minWidth: '900px', minHeight: '591px'}
          if (this.ccFlag) {
            res = {minWidth: '900px', minHeight: '475px'}
          }
          return res
        } catch (e) {
          return {minWidth: '900px', minHeight: '591px'}
        }
      },
      localeItems () {
        return [
          {
            value: 1,
            label: this.$t('cmn.options_kr')
          },
          {
            value: 2,
            label: this.$t('cmn.options_en')
          }
          // {
          //   value: 3,
          //   label: this.$t('cmn.options_jp')
          // }
        ]
      },
      footerBtn () {
        return this.isCheckIn ? ['close'] : ['confirm']
      },
      isChangedOtpMenu () {
        try {
          return _.get(this.updatedOtpMenu, ['length'], 0) > 0 && !this.compareOtpMenu(this.beforeApplyOtpMenu, this.updatedOtpMenu)
        } catch (e) {
          return false
        }
      }
    },
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {},
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {},
    destroyed () {},
    errorCaptured () {},
    methods: {
      ...myAccountSettingsHelpers.mapMutations([
        'initState'
      ]),
      ...myAccountSettingsHelpers.mapActions([
        'getMyAccountInfo',
        'editMyAccountInfo',
        'getMyAccountOtpMenu',
        'updateMyAccountOtpMenu'
      ]),

      isChanged () {
        if (typeof this.myAccountInfo !== 'undefined') {
          const keys = Object.keys(this.myAccountInfo)
          let isMatch = true
          isMatch = keys.every(key => this.myAccountInfo[key] === this.tempMyAccountInfo[key])

          if (this.profileAction !== 0) {
            isMatch = false
          }

          if (this.isChangedOtpMenu) {
            isMatch = false
          }

          return !isMatch
        }
        return false
      },

      compareOtpMenu (menu, targetMenu) {
        try {
          if (_.get(menu, ['length'], 0) !== _.get(targetMenu, ['length'], 0)) {
            return false
          }

          // 메뉴 리스트 정렬순서는 동일하다고 가정
          const otpMenuPick = ['admin_otp_menu_enable_yn', 'admin_otp_menu_id', 'admin_otp_menu_name']
          return menu.every((item, idx) => {
            const targetItem = targetMenu[idx]
            return otpMenuPick.every(key => {
              if (key === 'admin_otp_menu_enable_yn') {
                return Boolean(item[key]) === Boolean(targetItem[key])
              } else {
                return item[key] === targetItem[key]
              }
            })
          })
        } catch (e) {
          this.$log('[My Account Settings Error (onConfirmOtpKey)]', e)
        }
        return true
      },

      onHide () {
        this.$refs.layoutPopUp.hide()
      },
      async show () {
        // init
        this.profileImageFile = void 0
        this.profileImageUrl = ''
        this.profileImagePath = ''
        this.profileAction = 0
        this.tempMyAccountInfo = {}
        this.beforeApplyOtpMenu = []
        this.otpMenu = []
        this.updatedOtpMenu = []

        // await this.initStore()
        await this.initState()
        await this.loadMyAccountInfo()
        this.$refs.profileImageUploader.reset() // 업로드 컴포넌트 초기화

        await this.validatorClear()
        await this.$refs.layoutPopUp.show()
        if (this.isCheckIn) {
          this.$alertPopUp.show(this.$t('msg.restrictedFunctionCheckInMode'))
        }
      },
      init () {},
      async loadMyAccountInfo () {
        this.$refs.globalLoadingDialog.show()

        await this.getMyAccountInfo()

        if (this.myAccountInfo.img_cnt) {
          const url = `/api/co/my-account/profile?timestamp=${new Date().getTime()}`
          this.profileImagePath = url
          this.profileImageUrl = url
        } else {
          this.profileImagePath = ''
          this.profileImageUrl = ''
        }

        this.tempMyAccountInfo = _.cloneDeep(this.myAccountInfo)

        this.$refs.globalLoadingDialog.hide()
      },
      async validate () {
        try {
          if (this.tempMyAccountInfo.admin_otp_enable_yn === 1 &&
            _.get(this.tempMyAccountInfo, ['admin_otp_key', 'length'], 0) === 0) {
            const globalAlertPopup = this.$store.state.common.common.components.alertDialog
            globalAlertPopup.show(this.$t('msg.requiredOtpKey'), 'error')
            return false
          }

          await this.validatorClear()
          const valOk = await this.validateMixins('myaccount')
          if (valOk) {
            return true
          }
        } catch (e) {
          this.$log('[My Account Settings Error (validate)]', e)
        }
        return false
      },
      async onConfirm () {
        if (this.isChanged()) {
          this.editItem()
        } else {
          // this.$refs.globalAlertDialog.show(this.$t('msg.isNotChangeData'))
          this.onHide()
        }
      },
      async editItem () {
        const validateOk = await this.validate()
        if (!validateOk) {
          return
        }

        const params = {
          admin_name: _.isEmpty(this.tempMyAccountInfo.admin_name) ? '' : this.tempMyAccountInfo.admin_name,
          admin_desc: _.isEmpty(this.tempMyAccountInfo.admin_desc) ? '' : this.tempMyAccountInfo.admin_desc,
          admin_locale_type: Number(this.tempMyAccountInfo.admin_locale_type),
          admin_email: _.isEmpty(this.tempMyAccountInfo.admin_email) ? '' : this.tempMyAccountInfo.admin_email,
          admin_depart_name: _.isEmpty(this.tempMyAccountInfo.admin_depart_name) ? '' : this.tempMyAccountInfo.admin_depart_name,
          admin_phone: _.isEmpty(this.tempMyAccountInfo.admin_phone) ? '' : this.tempMyAccountInfo.admin_phone,
          admin_profile: this.profileImageFile || '',
          admin_profile_action: this.profileAction,
          admin_otp_enable_yn: this.tempMyAccountInfo.admin_otp_enable_yn,
          admin_otp_type: 1,
          admin_otp_key: _.isEmpty(this.tempMyAccountInfo.admin_otp_key) ? '' : this.tempMyAccountInfo.admin_otp_key
        }

        const { code, result } = await this.editMyAccountInfo(params)

        if (code === 'ok') {
          let msg = this.$t('msg.apply')

          // 고급 설정 - OTP 설정
          const
            otpPick = ['admin_otp_enable_yn', 'admin_otp_type', 'admin_otp_key'],
            myAccountOtpInfo = _.pick(this.myAccountInfo, otpPick),
            tempOtpInfo = _.pick(this.tempMyAccountInfo, otpPick)

          if (!compareObject(myAccountOtpInfo, tempOtpInfo) ||
            this.isChangedOtpMenu) {
            msg += `\n${this.$t('msg.changeOtpSettings')}`
          }

          // 고급 설정 - 언어 설정
          if (Number(this.myAccountInfo.admin_locale_type) !== Number(this.tempMyAccountInfo.admin_locale_type)) {
            msg += `\n${this.$t('msg.changeLanguageSettings')}`
          }

          this.$refs.globalAlertDialog.show(msg)
          this.onHide()
        } else {
          this.$refs.globalAlertDialog.show(result.msg, 'error')
        }

        // TODO: backend 체크인으로 변경 필요, 화면 내 c시 개별 조작할 수 없음
        // await this.commandCheckIn()
        // if (this.isCheckIn) {
        //   const params = {
        //     admin_name: this.tempMyAccountInfo.admin_name,
        //     admin_desc: this.tempMyAccountInfo.admin_desc,
        //     admin_locale_type: this.tempMyAccountInfo.admin_locale_type,
        //     admin_email: this.tempMyAccountInfo.admin_email,
        //     admin_depart_name: this.tempMyAccountInfo.admin_depart_name,
        //     admin_phone: this.tempMyAccountInfo.admin_phone,
        //     admin_profile: this.profileImageFile || '',
        //     admin_profile_action: this.profileAction
        //   }
        //
        //   const { code, result } = await this.editMyAccountInfo(params)
        //
        //   if (code === 'ok') {
        //     this.onHide()
        //   } else {
        //     this.$refs.globalAlertDialog.show(result.msg, 'error')
        //   }
        //   // 성공 실패에 관계 없이 체크아웃
        //   this.commandCheckOut()
        // } else {
        //   this.$refs.globalAlertDialog.show(this.$t('cmn.checkin_msg_alreadyCheckIn'), 'error')
        // }
      },
      onFileSelected (file) {
        if (file.length > 0) {
          // 확장자 검사
          const fileName = file[0].name,
            fileExt = path.extname(fileName)
          if (this.fileExtensions.indexOf(fileExt.toLowerCase()) === -1) {
            this.$alertPopUp.show(this.$t('msg.fileExtensionWarning', { extension: this.fileExtensions }))
            this.$refs.profileImageUploader.reset()
            return
          }
          // 파일 용량 제한
          const fileSize = file[0].size
          if (fileSize > this.uploadMaxSize) {
            this.$alertPopUp.show(this.$t('msg.uploadLimitSize', { size: fileSizeConverter(this.uploadMaxSize) }))
            this.$refs.profileImageUploader.reset()
            return
          }

          this.profileImageFile = file[0]
          this.profileAction = 1
          const reader = new FileReader()

          reader.addEventListener('load', () => {
            this.profileImagePath = reader.result
          })

          reader.readAsDataURL(this.profileImageFile)
        }
      },
      onFileRemoved (file) {
        this.profileImageFile = void 0
        this.profileImagePath = ''
        this.profileImageUrl = ''
        this.profileAction = 2
      },
      onRemovePhoto () {
        this.profileImageFile = void 0
        this.profileImagePath = ''
        this.profileImageUrl = ''
        this.profileAction = 2
        this.$refs.profileImageUploader.reset()
        // const selectedId = (this.treeInfo.id === 0) ? 1 : this.treeInfo.id
        // const inputGroup = (this.adminGeneral.admin_id === undefined) ? selectedId : this.adminGeneral.admin_id
        // const payload = {
        //   // admin_id: this.adminGeneral.admin_id,
        //   admin_id: inputGroup,
        //   params: this.getPhotoData()
        // }
        // await this.acsAdminManagersAllId(payload)
      },
      async onPasswordChange () {
        this.$refs.passwordChangePopup.show()
      },
      // OTP KEY 입력 팝업
      onClickSecuiOtp () {
        // secui otp
        this.$refs.adminOtpPopup.show(this.tempMyAccountInfo.admin_otp_key)
      },
      // SECUI OTP 설정 메뉴
      async onClickSecuiOtpMenu () {
        try {
          if (typeof this.$refs.contentsSetPopup === 'undefined') {
            return
          }

          const adminId = this.$store.state.common.common.uiData.user.adm_id
          const res = await this.getMyAccountOtpMenu({ adminId })
          if (res.code === 'ok') {
            this.otpMenu = _.map(res.result, menu => {
              // 로그인 (항상 체크, 비활성화)
              if (menu.admin_otp_menu_id === 1) {
                menu.admin_otp_menu_enable_yn = 1
                menu.disabled = true
              }
              return menu
            })

            // 변경 전 OTP Menu 설정 정보 (비교용, 최초 설정이 되어 있지 않은 경우)
            if (_.get(this.beforeApplyOtpMenu, ['length'], 0) === 0) {
              this.beforeApplyOtpMenu = _.cloneDeep(this.otpMenu)
            }

            this.$nextTick(() => {
              this.$refs.contentsSetPopup.show()
            })
          }
        } catch (e) {
          this.$log('[My Account Settings Error (onClickSecuiOtpMenu)]', e)
        }
      },
      async onConfirmOtpMenu ({ listData }) {
        try {
          // otpMenu와 비교 (1회 이상 호출된 이후 고려)
          if (_.get(listData, ['length'], 0) > 0 &&
            !this.compareOtpMenu(this.otpMenu, listData)) {
            const adminId = this.$store.state.common.common.uiData.user.adm_id
            const res = await this.updateMyAccountOtpMenu({
              adminId,
              otpMenu: listData
            })
            if (res.code === 'ok') {
              this.updatedOtpMenu = listData // compare 용

              this.$refs.contentsSetPopup.hide()
            } else {
              const globalAlertDialog = this.$store.state.common.common.components.alertDialog
              globalAlertDialog.show(res.result.msg, 'error')
            }
          }
        } catch (e) {
          this.$log('[My Account Settings Error (onConfirmOtpMenu)]', e)
        }
      },
      onConfirmOtpKey (adminOtpKey) {
        try {
          if (_.get(adminOtpKey, ['length'], 0) > 0) {
            this.tempMyAccountInfo.admin_otp_key = adminOtpKey
          }
        } catch (e) {
          this.$log('[My Account Settings Error (onConfirmOtpKey)]', e)
        }
      }
    },
    watch: {}
  }
</script>

<style scoped>
</style>
